import { KProperty1ca4yb4wlo496 as KProperty1 } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import {
  getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef,
  constructCallableReference23y65rf941mch as constructCallableReference,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { startsWith26w8qjqapeeq6 as startsWith } from '../../../../../../kotlin-kotlin-stdlib/kotlin/text/stringsCode.mjs';
import { get_native16zxqjg6lrtlz as get_native } from '../NativeElement.commonHtml.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  resizeObserver1rxn81hcox9er as resizeObserver,
  mutationObserver1idzofyamtyii as mutationObserver,
} from './helpers.commonHtml.js.mjs';
import { lazy2hsh8ze7j6ikd as lazy } from '../../../../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import {
  ReactiveLoading_getInstance3l9yi71a4isfm as ReactiveLoading_getInstance,
  reactive2xic0rufq5s8n as reactive,
} from '../../../../../../reactive/com/lightningkite/reactive/context/ReactiveContext.mjs';
import {
  Size2b01934yxlz5f as Size,
  Companion_getInstance1vsa8jrdqad0h as Companion_getInstance,
} from '../../models/Rect.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { vevent2d70lzbz6q2i1 as vevent } from './helpers.commonHtml.mjs';
import {
  BasicListenable3uz4a8xs34a0h as BasicListenable,
  Signal1973xs1vkmdcb as Signal,
} from '../../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import { to2cs3ny02qtbcb as to } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
import {
  Default_getInstance27jodt8hd1bac as Default_getInstance,
  get_debugMode2ku08uo1anfv as get_debugMode,
} from '../../debugger.mjs';
import { Debugger_getInstancengm4b9abzu1y as Debugger_getInstance } from '../Element.mjs';
import { equals2au1ep9vhcato as equals } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { removeAll3cm9rh0qak2y6 as removeAll } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/MutableCollections.mjs';
import { toString30pk9tzaqopn as toString } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { addClass1ihnmxbr5xjr2 as addClass } from '../../../../../../kotlin_org_jetbrains_kotlin_kotlin_dom_api_compat/kotlinx/dom/Classes.mjs';
import {
  fromInt2ii0rejb1w62w as fromInt,
  convertToInty04h231mmjoh as convertToInt,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function _get_ro__ndca26($this) {
  var tmp0 = $this.ro$delegate_1;
  var tmp = KProperty1();
  // Inline function 'kotlin.getValue' call
  getPropertyCallableRef('ro', 1, tmp, ScrollingBehaviorImpl$_get_ro_$ref_fo7qe2(), null);
  return tmp0.get_value_j01efc_k$();
}
function _get_mo__ndc6cp($this) {
  var tmp0 = $this.mo$delegate_1;
  var tmp = KProperty1();
  // Inline function 'kotlin.getValue' call
  getPropertyCallableRef('mo', 1, tmp, ScrollingBehaviorImpl$_get_mo_$ref_dbcd91(), null);
  return tmp0.get_value_j01efc_k$();
}
function _get_clientSize__y98xgh($this) {
  var tmp0 = $this.clientSize$delegate_1;
  var tmp = KProperty1();
  // Inline function 'kotlin.getValue' call
  getPropertyCallableRef('clientSize', 1, tmp, ScrollingBehaviorImpl$_get_clientSize_$ref_9870qd(), null);
  return tmp0.get_value_j01efc_k$();
}
function _get_scrollSize__2rvopp($this) {
  var tmp0 = $this.scrollSize$delegate_1;
  var tmp = KProperty1();
  // Inline function 'kotlin.getValue' call
  getPropertyCallableRef('scrollSize', 1, tmp, ScrollingBehaviorImpl$_get_scrollSize_$ref_utz749(), null);
  return tmp0.get_value_j01efc_k$();
}
function ScrollingBehaviorImpl$_get_ro_$ref_fo7qe2() {
  return constructCallableReference((p0) => _get_ro__ndca26(p0), 1, 0, 137);
}
function ScrollingBehaviorImpl$_get_mo_$ref_dbcd91() {
  return constructCallableReference((p0) => _get_mo__ndc6cp(p0), 1, 0, 138);
}
function ScrollingBehaviorImpl$_get_clientSize_$ref_9870qd() {
  return constructCallableReference((p0) => _get_clientSize__y98xgh(p0), 1, 0, 139);
}
function ScrollingBehaviorImpl$_get_scrollSize_$ref_utz749() {
  return constructCallableReference((p0) => _get_scrollSize__2rvopp(p0), 1, 0, 140);
}
function ScrollingBehaviorImpl$_get_viewport_$ref_fm96gf() {
  return constructCallableReference((p0) => p0.get_viewport_c0gm8h_k$(), 1, 0, 141);
}
function ScrollingBehaviorImpl$_set_snapToElements_$lambda_larv83(it) {
  return startsWith(it, 'snapTo-');
}
function ScrollingBehaviorImpl$disableSnapTemporarily$lambda(it) {
  return startsWith(it, 'snapTo-');
}
var ScrollingBehaviorImplClass;
function ScrollingBehaviorImpl() {
  if (ScrollingBehaviorImplClass === VOID) {
    class $ {
      constructor(on, horizontal, vertical) {
        this.on_1 = on;
        this.horizontal_1 = horizontal;
        this.vertical_1 = vertical;
        this.native_1 = get_native(this.on_1);
        if (this.horizontal_1) {
          var tmp0 = this.native_1.classes_1;
          // Inline function 'kotlin.collections.plusAssign' call
          var element = 'scroll-horizontal';
          tmp0.add_utx5q5_k$(element);
          // Inline function 'com.lightningkite.kiteui.views.overflowX' call
          this.native_1.style_1.native_1.overflowX = 'auto';
        } else {
          // Inline function 'com.lightningkite.kiteui.views.overflowX' call
          this.native_1.style_1.native_1.overflowX = 'none';
        }
        if (this.vertical_1) {
          var tmp0_0 = this.native_1.classes_1;
          // Inline function 'kotlin.collections.plusAssign' call
          var element_0 = 'scroll-vertical';
          tmp0_0.add_utx5q5_k$(element_0);
          // Inline function 'com.lightningkite.kiteui.views.overflowY' call
          this.native_1.style_1.native_1.overflowY = 'auto';
        } else {
          // Inline function 'com.lightningkite.kiteui.views.overflowY' call
          this.native_1.style_1.native_1.overflowY = 'none';
        }
        this.showScrollBars_1 = true;
        var tmp = this;
        tmp.ro$delegate_1 = lazy(() => resizeObserver(this.native_1));
        var tmp_0 = this;
        tmp_0.mo$delegate_1 = lazy(() => mutationObserver(this.native_1, true));
        var tmp_1 = this;
        tmp_1.clientSize$delegate_1 = lazy(() => reactive(this.on_1, VOID, ($this$reactive) => {
          $this$reactive.rerunOn_6homfr_k$(_get_ro__ndca26(this));
          var tmp0_safe_receiver = this.native_1.element_1;
          var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.clientWidth;
          var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver;
          var tmp;
          if (tmp2_elvis_lhs == null) {
            throw ReactiveLoading_getInstance();
          } else {
            tmp = tmp2_elvis_lhs;
          }
          var tmp_0 = tmp;
          var tmp3_safe_receiver = this.native_1.element_1;
          var tmp4_safe_receiver = tmp3_safe_receiver == null ? null : tmp3_safe_receiver.clientHeight;
          var tmp5_elvis_lhs = tmp4_safe_receiver == null ? null : tmp4_safe_receiver;
          var tmp_1;
          if (tmp5_elvis_lhs == null) {
            throw ReactiveLoading_getInstance();
          } else {
            tmp_1 = tmp5_elvis_lhs;
          }
          return new (Size())(tmp_0, tmp_1);
        }));
        var tmp_2 = this;
        tmp_2.scrollSize$delegate_1 = lazy(() => reactive(this.on_1, VOID, ($this$reactive) => {
          $this$reactive.rerunOn_6homfr_k$(_get_ro__ndca26(this));
          $this$reactive.rerunOn_6homfr_k$(_get_mo__ndc6cp(this));
          var tmp0_safe_receiver = this.native_1.element_1;
          var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.scrollWidth;
          var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver;
          var tmp;
          if (tmp2_elvis_lhs == null) {
            throw ReactiveLoading_getInstance();
          } else {
            tmp = tmp2_elvis_lhs;
          }
          var tmp_0 = tmp;
          var tmp3_safe_receiver = this.native_1.element_1;
          var tmp4_safe_receiver = tmp3_safe_receiver == null ? null : tmp3_safe_receiver.scrollHeight;
          var tmp5_elvis_lhs = tmp4_safe_receiver == null ? null : tmp4_safe_receiver;
          var tmp_1;
          if (tmp5_elvis_lhs == null) {
            throw ReactiveLoading_getInstance();
          } else {
            tmp_1 = tmp5_elvis_lhs;
          }
          return new (Size())(tmp_0, tmp_1);
        }));
        this.scrollEvent_1 = vevent(this.native_1, 'scroll');
        this.lockScrollEnd_1 = BasicListenable().new_com_lightningkite_reactive_core_BasicListenable_biohma_k$();
        this.lockScrollReportAt_1 = null;
        var tmp_3 = this;
        tmp_3.viewport$delegate_1 = lazy(() => reactive(this.on_1, VOID, ($this$reactive) => {
          $this$reactive.rerunOn_6homfr_k$(this.scrollEvent_1);
          $this$reactive.rerunOn_6homfr_k$(this.lockScrollEnd_1);
          var tmp0_elvis_lhs = this.lockScrollReportAt_1;
          var tmp;
          if (tmp0_elvis_lhs == null) {
            var tmp_0 = Companion_getInstance();
            var tmp1_safe_receiver = this.native_1.element_1;
            var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.scrollLeft;
            var tmp_1 = tmp2_elvis_lhs == null ? 0.0 : tmp2_elvis_lhs;
            var tmp3_safe_receiver = this.native_1.element_1;
            var tmp4_elvis_lhs = tmp3_safe_receiver == null ? null : tmp3_safe_receiver.scrollTop;
            tmp = tmp_0.fromSize_jwt73p_k$(tmp_1, tmp4_elvis_lhs == null ? 0.0 : tmp4_elvis_lhs, $this$reactive.invoke_r7m7el_k$(_get_clientSize__y98xgh(this)).width_1, $this$reactive.invoke_r7m7el_k$(_get_clientSize__y98xgh(this)).height_1);
          } else {
            tmp = tmp0_elvis_lhs;
          }
          return tmp;
        }));
        var tmp_4 = this;
        tmp_4.content$delegate_1 = lazy(() => reactive(this.on_1, VOID, ($this$reactive) => Companion_getInstance().fromSize_jwt73p_k$(0.0, 0.0, $this$reactive.invoke_r7m7el_k$(_get_scrollSize__2rvopp(this)).width_1, $this$reactive.invoke_r7m7el_k$(_get_scrollSize__2rvopp(this)).height_1)));
        this._directlyInteractingWithScroller_1 = Signal().new_com_lightningkite_reactive_core_Signal_8ohyj8_k$(false);
        this.snapToElements_1 = to(null, null);
        this.scrollSnapStop_1 = false;
        this.scrollToInstance_1 = 0;
      }
      set_showScrollBars_vutwwi_k$(value) {
        this.showScrollBars_1 = value;
        if (value) {
          var tmp0 = this.native_1.classes_1;
          // Inline function 'kotlin.collections.minusAssign' call
          var element = 'hideScrollbar';
          tmp0.remove_cedx0m_k$(element);
        } else {
          var tmp0_0 = this.native_1.classes_1;
          // Inline function 'kotlin.collections.plusAssign' call
          var element_0 = 'hideScrollbar';
          tmp0_0.add_utx5q5_k$(element_0);
        }
      }
      get_viewport_c0gm8h_k$() {
        var tmp0 = this.viewport$delegate_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('viewport', 1, tmp, ScrollingBehaviorImpl$_get_viewport_$ref_fm96gf(), null);
        return tmp0.get_value_j01efc_k$();
      }
      set_snapToElements_l1ws84_k$(value) {
        // Inline function 'com.lightningkite.kiteui.debugPrint' call
        var this_0 = this.on_1;
        if (get_debugMode() && equals(Debugger_getInstance().debugTarget_1, this_0)) {
          var tmp = Default_getInstance().tag_ioihsw_k$('viewDebugTarget');
          var tmp$ret$1 = 'ScrollView.snapToElements set';
          tmp.info_59mt0k_k$([tmp$ret$1]);
        }
        this.snapToElements_1 = value;
        var tmp_0 = this.native_1.classes_1;
        removeAll(tmp_0, ScrollingBehaviorImpl$_set_snapToElements_$lambda_larv83);
        this.native_1.classes_1.add_utx5q5_k$('snapTo-' + toString(value.first_1) + '-' + toString(value.second_1));
        this.native_1.setStyleProperty_wavvb3_k$('scroll-snap-type', !(value.first_1 == null) && !(value.second_1 == null) ? 'both mandatory' : !(value.first_1 == null) ? 'x mandatory' : !(value.second_1 == null) ? 'y mandatory' : 'none');
      }
      set_ignoreInteraction_ww4hrm_k$(value) {
      }
      scrollTo_gbpwk3_k$(left, top, animated) {
        // Inline function 'com.lightningkite.kiteui.debugPrint' call
        var this_0 = this.on_1;
        if (get_debugMode() && equals(Debugger_getInstance().debugTarget_1, this_0)) {
          var tmp = Default_getInstance().tag_ioihsw_k$('viewDebugTarget');
          var tmp$ret$1 = 'ScrollView.scrollTo(' + left + ', ' + top + ', ' + animated + ')';
          tmp.info_59mt0k_k$([tmp$ret$1]);
        }
        this.disableSnapTemporarily_8l8hlt_k$();
        // Inline function 'com.lightningkite.kiteui.views.FutureElement.onElement' call
        var this_1 = this.native_1;
        var tmp0_safe_receiver = this_1.element_1;
        var tmp_0;
        if (tmp0_safe_receiver == null) {
          tmp_0 = null;
        } else {
          // Inline function 'kotlin.let' call
          var tmp_1 = tmp0_safe_receiver instanceof HTMLElement ? tmp0_safe_receiver : THROW_CCE();
          var tmp_2;
          if (animated) {
            // Inline function 'org.w3c.dom.SMOOTH' call
            // Inline function 'kotlin.js.asDynamic' call
            // Inline function 'kotlin.js.unsafeCast' call
            tmp_2 = 'smooth';
          } else {
            // Inline function 'org.w3c.dom.INSTANT' call
            // Inline function 'kotlin.js.asDynamic' call
            // Inline function 'kotlin.js.unsafeCast' call
            tmp_2 = 'instant';
          }
          // Inline function 'org.w3c.dom.ScrollToOptions' call
          var behavior = tmp_2;
          var o = {};
          o['left'] = left;
          o['top'] = top;
          o['behavior'] = behavior;
          tmp_1.scrollTo(o);
          tmp_0 = Unit_instance;
        }
        if (tmp_0 == null) {
          this_1.elementToDo_1.add_utx5q5_k$((it) => {
            var tmp = it instanceof HTMLElement ? it : THROW_CCE();
            var tmp0 = left;
            var tmp2 = top;
            var tmp_0;
            if (animated) {
              // Inline function 'org.w3c.dom.SMOOTH' call
              // Inline function 'kotlin.js.asDynamic' call
              // Inline function 'kotlin.js.unsafeCast' call
              tmp_0 = 'smooth';
            } else {
              // Inline function 'org.w3c.dom.INSTANT' call
              // Inline function 'kotlin.js.asDynamic' call
              // Inline function 'kotlin.js.unsafeCast' call
              tmp_0 = 'instant';
            }
            // Inline function 'org.w3c.dom.ScrollToOptions' call
            var behavior = tmp_0;
            var o = {};
            o['left'] = tmp0;
            o['top'] = tmp2;
            o['behavior'] = behavior;
            tmp.scrollTo(o);
            return Unit_instance;
          });
        }
      }
      disableSnapTemporarily_8l8hlt_k$() {
        var tmp = this.native_1.classes_1;
        removeAll(tmp, ScrollingBehaviorImpl$disableSnapTemporarily$lambda);
        this.native_1.setStyleProperty_wavvb3_k$('scroll-snap-type', 'unset');
      }
      scrollToKeepAnimations_lpstn0_k$(x, y) {
        this.scrollToInstance_1 = this.scrollToInstance_1 + 1 | 0;
        var myInstance = this.scrollToInstance_1;
        // Inline function 'com.lightningkite.kiteui.debugPrint' call
        var this_0 = this.on_1;
        if (get_debugMode() && equals(Debugger_getInstance().debugTarget_1, this_0)) {
          var tmp = Default_getInstance().tag_ioihsw_k$('viewDebugTarget');
          var tmp$ret$1 = 'ScrollView.scrollToKeepAnimations(' + x + ', ' + y + ')';
          tmp.info_59mt0k_k$([tmp$ret$1]);
        }
        this.disableSnapTemporarily_8l8hlt_k$();
        // Inline function 'com.lightningkite.kiteui.views.FutureElement.onElement' call
        var this_1 = this.native_1;
        var tmp0_safe_receiver = this_1.element_1;
        var tmp_0;
        if (tmp0_safe_receiver == null) {
          tmp_0 = null;
        } else {
          // Inline function 'kotlin.let' call
          var it = tmp0_safe_receiver;
          if (!(it instanceof HTMLElement))
            THROW_CCE();
          addClass(it, ['suppress-overflow-anchors']);
          var tmp_1 = this;
          var tmp_2 = Companion_getInstance();
          var tmp0_safe_receiver_0 = this.native_1.element_1;
          var tmp1_safe_receiver = tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.clientWidth;
          var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver;
          var tmp_3 = tmp2_elvis_lhs == null ? 0.0 : tmp2_elvis_lhs;
          var tmp3_safe_receiver = this.native_1.element_1;
          var tmp4_safe_receiver = tmp3_safe_receiver == null ? null : tmp3_safe_receiver.clientHeight;
          var tmp5_elvis_lhs = tmp4_safe_receiver == null ? null : tmp4_safe_receiver;
          tmp_1.lockScrollReportAt_1 = tmp_2.fromSize_jwt73p_k$(x, y, tmp_3, tmp5_elvis_lhs == null ? 0.0 : tmp5_elvis_lhs);
          it.scrollLeft = x;
          it.scrollTop = y;
          var amount = 32;
          var inductionVariable = 1;
          var last = amount - 1 | 0;
          if (inductionVariable <= last)
            do {
              var count = inductionVariable;
              inductionVariable = inductionVariable + 1 | 0;
              var tmp_4 = window;
              tmp_4.setTimeout(() => {
                var tmp;
                if (!(myInstance === this.scrollToInstance_1)) {
                  return Unit_instance;
                }
                it.scrollLeft = x;
                it.scrollTop = y;
                return Unit_instance;
              }, count);
            }
             while (!(count === last));
          // Inline function 'com.lightningkite.kiteui.afterTimeout' call
          var milliseconds = fromInt(amount);
          var tmp_5 = window;
          var handle = tmp_5.setTimeout(() => {
            $l$block: {
              if (!(myInstance === this.scrollToInstance_1)) {
                break $l$block;
              }
              if (!(this.snapToElements_1.first_1 == null) || !(this.snapToElements_1.second_1 == null)) {
                this.set_snapToElements_l1ws84_k$(this.snapToElements_1);
                it.scrollLeft = x;
                it.scrollTop = y;
              }
              this.lockScrollReportAt_1 = null;
              this.lockScrollEnd_1.invokeAll_w2le0p_k$();
            }
            return Unit_instance;
          }, convertToInt(milliseconds));
          tmp_0 = Unit_instance;
        }
        if (tmp_0 == null) {
          this_1.elementToDo_1.add_utx5q5_k$((it) => {
            var it_0 = it;
            if (!(it_0 instanceof HTMLElement))
              THROW_CCE();
            addClass(it_0, ['suppress-overflow-anchors']);
            var tmp = this;
            var tmp_0 = Companion_getInstance();
            var tmp0_safe_receiver = this.native_1.element_1;
            var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.clientWidth;
            var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver;
            var tmp_1 = tmp2_elvis_lhs == null ? 0.0 : tmp2_elvis_lhs;
            var tmp3_safe_receiver = this.native_1.element_1;
            var tmp4_safe_receiver = tmp3_safe_receiver == null ? null : tmp3_safe_receiver.clientHeight;
            var tmp5_elvis_lhs = tmp4_safe_receiver == null ? null : tmp4_safe_receiver;
            tmp.lockScrollReportAt_1 = tmp_0.fromSize_jwt73p_k$(x, y, tmp_1, tmp5_elvis_lhs == null ? 0.0 : tmp5_elvis_lhs);
            it_0.scrollLeft = x;
            it_0.scrollTop = y;
            var amount = 32;
            var inductionVariable = 1;
            var last = amount - 1 | 0;
            if (inductionVariable <= last)
              do {
                var count = inductionVariable;
                inductionVariable = inductionVariable + 1 | 0;
                var tmp_2 = window;
                tmp_2.setTimeout(() => {
                  var tmp;
                  if (!(myInstance === this.scrollToInstance_1)) {
                    return Unit_instance;
                  }
                  it_0.scrollLeft = x;
                  it_0.scrollTop = y;
                  return Unit_instance;
                }, count);
              }
               while (!(count === last));
            // Inline function 'com.lightningkite.kiteui.afterTimeout' call
            var milliseconds = fromInt(amount);
            var tmp_3 = window;
            var handle = tmp_3.setTimeout(() => {
              $l$block_0: {
                if (!(myInstance === this.scrollToInstance_1)) {
                  break $l$block_0;
                }
                if (!(this.snapToElements_1.first_1 == null) || !(this.snapToElements_1.second_1 == null)) {
                  this.set_snapToElements_l1ws84_k$(this.snapToElements_1);
                  it_0.scrollLeft = x;
                  it_0.scrollTop = y;
                }
                this.lockScrollReportAt_1 = null;
                this.lockScrollEnd_1.invokeAll_w2le0p_k$();
              }
              return Unit_instance;
            }, convertToInt(milliseconds));
            return Unit_instance;
          });
        }
      }
    }
    initMetadataForClass($, 'ScrollingBehaviorImpl');
    ScrollingBehaviorImplClass = $;
  }
  return ScrollingBehaviorImplClass;
}
//region block: exports
export {
  ScrollingBehaviorImpl as ScrollingBehaviorImpl35p8dxbs74spr,
};
//endregion

//# sourceMappingURL=ScrollView.commonHtml.js.mjs.map
